/* eslint-disable camelcase */
import React from 'react';
import { StyledContent } from './ContentStyles';

const ContentTruncated = (blog_post_content, extraClass, substringOverride) => {
  let contentTruncated;

  if (blog_post_content) {
    contentTruncated = (
      <StyledContent className={extraClass}>
        {blog_post_content[0].text.substring(0, substringOverride ? substringOverride : 64)} ...
      </StyledContent>
    );
  }
  return contentTruncated;
};

export default ContentTruncated;
